import { useEffect } from "react";

export default function useSaveScrollBeforeNav() {
  useEffect(() => {
    const handleClick = (e) => {
      const link = e.target.closest("a");
      if (link && link.href && link.origin === window.location.origin) {
        // salvează scrollul actual înainte de navigare
        const path = window.location.pathname;
        const y = window.scrollY.toString();
        sessionStorage.setItem(`scroll-${path}`, y);
        // console.log("💾 Scroll salvat înainte de navigare din", path, "→", y);
      }
    };

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);
}
